export default "__VITE_ASSET__c4d738c1__"